import React from "react";
import {Box, Typography, Grid, useTheme} from "@mui/material";
import {FormField} from "./FormField";

export const FormContent = ({formik, formMap, profile}) => {
    const theme = useTheme()

    const Title = ({title}) => {
        return (<Box sx={{pb:1}}>
            <Typography fontWeight={'bold'} variant={'h6'}>{title}</Typography>
            <Box sx={{width:'5rem', height:'0.3rem', background:"#F96332"}}/>
        </Box>)
    }

    return (
        <Box>
            {formMap.map((section, index) => {
                if (section.conditions) {
                    let render = []
                    section.conditions.predicates.forEach(predicate => {
                        let checked = formik.values[predicate.id] === predicate.value
                        render.push(checked)
                    })
                    if (render.includes(true)) {

                        return <Box key={index}>
                            <Title title={section.title}/>
                            <Grid container spacing={2}>
                                {section.fields.map((field, index) => {
                                        if (field.conditions) {
                                            let render = []
                                            field.conditions.predicates.forEach(predicate => {
                                                let checked = formik.values[predicate.id] === predicate.value
                                                render.push(checked)
                                            })
                                            if (render.includes(true)) {
                                                return <FormField formik={formik} key={index} name={field.name}
                                                                  id={field.id}
                                                                  label={field.label}
                                                                  type={field.type} values={field.values ?? []}
                                                                  cols={field.cols}
                                                                  precompiled={field.precompiled}
                                                                  disablePast={field.disablePast}
                                                                  disableFuture={field.disableFuture}
                                                                  row={field.row}
                                                                  profile={profile}
                                                />
                                            }
                                        } else {
                                            return <FormField formik={formik} key={index} name={field.name} id={field.id}
                                                              label={field.label}
                                                              type={field.type} values={field.values ?? []}
                                                              cols={field.cols}
                                                              precompiled={field.precompiled}
                                                              disablePast={field.disablePast}
                                                              disableFuture={field.disableFuture}
                                                              row={field.row}
                                                              profile={profile}
                                            />
                                        }
                                    }
                                )}
                            </Grid>
                        </Box>
                    }
                } else {
                    return <Box key={index} sx={{py: 1}}>
                        <Title title={section.title}/>
                        <Grid container spacing={2}>
                            {section.fields.map((field, index) => {
                                    if (field.conditions) {
                                        let render = []
                                        field.conditions.predicates.forEach(predicate => {
                                            let checked = formik.values[predicate.id] === predicate.value
                                            render.push(checked)
                                        })
                                        if (render.includes(true)) {
                                            return <FormField formik={formik} key={index} name={field.name} id={field.id}
                                                              label={field.label}
                                                              type={field.type} values={field.values ?? []}
                                                              cols={field.cols}
                                                              precompiled={field.precompiled}
                                                              disablePast={field.disablePast}
                                                              disableFuture={field.disableFuture}
                                                              row={field.row}
                                                              profile={profile}
                                            />
                                        }
                                    } else {
                                        return <FormField formik={formik} key={index} name={field.name} id={field.id}
                                                          label={field.label}
                                                          type={field.type} values={field.values ?? []}
                                                          cols={field.cols}
                                                          precompiled={field.precompiled}
                                                          disablePast={field.disablePast}
                                                          disableFuture={field.disableFuture}
                                                          row={field.row}
                                                          profile={profile}
                                        />
                                    }
                                }
                            )}
                        </Grid>
                    </Box>
                }
            })}
        </Box>
    )
}
